import React from 'react';
import config from '@jucy-nakuru/config/clientConfig';
import { mapBreakPoints } from '@jucy-ui/appearance';
import Box from '@mui/material/Box';
import Topbar from '../../Topbar';

interface HomeLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
    content: string;
}

const HomeLayout: React.FC<React.PropsWithChildren<HomeLayoutProps>> = ({ children }) => {
    const isTest = config.app.env === 'test';
    return (
        <Box
            sx={(theme) => ({
                paddingTop: theme.settings?.appBar.heights
                    ? mapBreakPoints(
                          theme.settings?.appBar.heights,
                          (height) => `${height + (isTest ? theme.settings?.appBar.testBannerHeight || 0 : 0)}px`
                      )
                    : 0,
                display: 'flex',
                alignItems: 'stretch',
                flex: 1,
            })}
        >
            <Topbar />
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    alignItems: { xs: 'stretch', sm: 'center' },
                    backgroundAttachment: 'fixed',
                    bgcolor: 'grey.50',
                    backgroundImage: 'var(--page-bg)',
                    backgroundPosition: 'top right',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        position: 'relative',
                        zIndex: 1,
                        minWidth: 300,
                        left: {
                            xs: 'unset',
                            sm: 75,
                        },
                        maxWidth: {
                            xs: 'unset',
                            sm: 360,
                        },
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
};

export default HomeLayout;
